import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "westpark-cluster-faded",
  "use": "westpark-cluster-faded-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\" id=\"westpark-cluster-faded\"><title>5B4F3BE4-31ED-481D-BAE7-567E106C3F85</title><circle cx=\"859\" cy=\"1004\" r=\"24\" transform=\"translate(-835 -980)\" fill=\"#7cbb9e\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol